module.exports = __webpack_public_path__ + "static/media/About_the_Halls.4d9a818c.md";